import { render, staticRenderFns } from "./UnitPercent.vue?vue&type=template&id=535f1d3b"
import script from "./UnitPercent.vue?vue&type=script&lang=js"
export * from "./UnitPercent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports